import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import "./VisionMission.css";
import Footer from "../components/Footer";
import Navbar from "../components/navbar";
import CTAButtons from "../components/sticky-button";
import PageHeader from "./PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

const VisionMission = () => {
  const [showForm, setShowForm] = useState(false);
  const asset = (path) => `${process.env.PUBLIC_URL}${path.startsWith('/') ? path : `/${path}`}`;

  return (
    <>
      <Navbar />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />
      <PageHeader
        title="Vision & Mission"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Rules & Guidelines" },
        ]}
      />
      <main className="vision-mission-container">


        {/* Vision & Mission */}
        <section className="vm-section">
          {/* Vision */}
          <article className="vm-block vm-block--reverse">
            <div className="vm-media">
              <img
                src={asset('/About/Vision.webp')}
                loading="lazy"
                alt="Vision illustration for Thakur Institute"
                className="vm-img"
              />
            </div>
            <div className="vm-content">
              <h2>Our Vision</h2>
              <div className="vm-underline" aria-hidden="true" />
              <p>
                Thakur Institute of Management Studies, Career Development & Research will become a globally recognized institute in Computer Applications, with focus on holistic development and research-oriented learning.               </p>
            </div>
          </article>

          {/* Mission */}
          <article className="vm-block">
            <div className="vm-media">
              <img
                src={asset('/About/Mission.webp')}
                loading="lazy"
                alt="Mission illustration for Thakur Institute"
                className="vm-img"
              />
            </div>
            <div className="vm-content">
              <h2 className="vm-heading">Our Mission</h2>
              <div className="vm-underline" aria-hidden="true" />
              <ul className="vm-text" style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '16px' }}>
                <li style={{ listStyleType: 'disc' }}>
                  To provide a conducive learning environment with state-of-the-art infrastructure for academic excellence
                </li>
                <li style={{ listStyleType: 'disc' }}>
                  To build leadership, research aptitude and entrepreneurial outlook through holistic, multidisciplinary and lifelong learning
                </li>
                <li style={{ listStyleType: 'disc' }}>
                  To promote innovation and problem-solving for real-world, sustainable and industry-relevant applications
                </li>
                <li style={{ listStyleType: 'disc' }}>
                  To strengthen professional competence, ethical values and social responsibility through academic–industry partnerships, community engagement and global awareness
                </li>
              </ul>
            </div>
          </article>
        </section>


      </main>
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />

      <Footer />
    </>
  );
};

export default VisionMission;
